export default "__VITE_ASSET__AuOgpTOD__"